module.exports = __webpack_public_path__ + "img/Frame4668.f4b6ebf7.png";